// extracted by mini-css-extract-plugin
export default {"wrapper":"singleCommentContentPopup_wrapper__cy8mC","header":"singleCommentContentPopup_header__s3X9A"};